import React, { useState } from "react";
import styled from "styled-components";
import { CommandDispatcher } from "../../../concepts/commands/CommandDispatcher";
import { ObjectManager } from "../../../concepts/objects";
import { Button, Colors } from "../../../ui";
import { PropertyFacade } from "../../canvas/properties/PropertyFacade";
import { PopoutWidget } from "../../canvas/workspace/widgets/WidgetInterface";
import { useResolve } from "../../Container";
import { Flexer } from "../../dashboard/elements/LayoutElements";
import { Spinner } from "./Spinner";
import { spinnerLoad } from "./SpinnerCommands";
import { SpinnerItem } from "./SpinnerItem";

const TextArea = styled.textarea`
    position: relative;
    width: 100%;
    height: 100%;
    padding: .5em;
    border: solid 1px #d2d6dc;
    border-radius: .25rem;
    resize: none;

    &:focus {
        border: solid 1px ${Colors.primary};
        box-shadow: 0 0 0 1px ${Colors.primary};
    }
`;

const getInitialValue = (spinners: Spinner[]) => {
    if (spinners.length === 1) {
        return spinners[0].polarize(SpinnerItem).map(x => x.text).join('\n');
    }
    return '';
};

export const SpinnerItemSetWidget = ({ widget }: { widget: PopoutWidget }) => {

    const dispatch = useResolve(CommandDispatcher);
    const objects = useResolve(ObjectManager);
    const facade = widget.facade as PropertyFacade<Spinner>;

    const spinners = facade.map(x => x);
    const [value, setValue] = useState(getInitialValue(spinners));

    const onApply = () => {
        const items = value.split('\n').map(x => x.trim()).filter(x => !!x);
        if (items.length === 0) return;
        objects.update(() => {
            for (const s of spinners) {
                dispatch(spinnerLoad, [s.id, ...items]);
            }
        });
        widget.update({ open: false });
    };

    return <Flexer flex="column" padding=".5" width="17.5" height="15" gap=".5">
        <Flexer grow>
            <TextArea placeholder="One item per line..." value={value} onChange={e => setValue(e.target.value)} />
        </Flexer>
        <Flexer shrink flex="row" justify="end">
            <Button size="sm" variant="primary" onAction={onApply}>Apply</Button>
        </Flexer>
    </Flexer>

    // private onSelect = (kind: ShapeKind) => () => {
    //     // This is hacky AF, I'm sorry:
    //     this.props.widget.update({
    //         open: false,
    //         value: kind,
    //     });
    // };
}
